import { Search } from "@mui/icons-material";
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  TextField,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import Draggable from "react-draggable";
// import { options } from "../../../../../i18next-scanner.config";
const DraggablePaper = (props) => (
  <Draggable
    handle="#draggable-title"
    cancel={'[class*="MuiDialogContent-root"]'}
  >
    <Paper {...props} />
  </Draggable>
);
const FilterModal = ({
  open,
  onClose,
  onSubmit,
  resetFilter,
  filters,
  handleFilterChange,
  countries,
  managers,
  ceoLevels,
  personTypes,
  grades,
  departments,
  workerTypes,
  jobFamiliesOptions,
  jobFunctions,
  legalEntitiesOptions,
  isSimulation,
}) => {
  const sortOptionsWithSelectedFirst = (
    options,
    selectedValues,
    isOptionAnObj = false
  ) => {
    return [...options].sort((a, b) => {
      let aSelected, bSelected, aLabel, bLabel;

      // // Detect if we're working with objects or strings
      // const isObjectArray =
      //   typeof options[0] === "object" && options[0] !== null;

      if (isOptionAnObj) {
        // Handle object arrays
        const selectedLabels =
          selectedValues.length > 0
            ? selectedValues.map((item) => item.label)
            : [];
        aSelected = selectedLabels.includes(a.label);
        bSelected = selectedLabels.includes(b.label);
        aLabel = a.label;
        bLabel = b.label;
      } else {
        // Handle string arrays
        aSelected = selectedValues.includes(a);
        bSelected = selectedValues.includes(b);
        aLabel = a;
        bLabel = b;
      }

      // Prioritize selected items
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;

      // Sort alphabetically within groups
      return aLabel.localeCompare(bLabel);
    });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperComponent={DraggablePaper}
        aria-labelledby="draggable-title"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiDialog-paper": {
            width: "95%",
            maxWidth: "none",
            borderRadius: "1rem",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px" }}>
          {I18n.get("Select filters")}
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              mb: 4,
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <Badge color="primary" badgeContent={filters.country.length || 0}>
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    countries,
                    filters.country,
                    false
                  )}
                  value={filters.country || null}
                  defaultValue={filters.country}
                  label="Country"
                  // inputValue={filters.country || ""}
                  onChange={(event, value) => {
                    handleFilterChange("country", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("country", newInputValue);
                  // }}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={isSimulation}
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Country"
                      multiline={false}
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                />
              </Badge>
              <Badge
                color="primary"
                badgeContent={filters.legal_entity.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    legalEntitiesOptions,
                    filters.legal_entity,
                    false
                  )}
                  value={filters.legal_entity || null}
                  label="Legal entity"
                  // inputValue={filters.legal_entity || ""}
                  onChange={(event, value) => {
                    handleFilterChange("legal_entity", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("legal_entity", newInputValue);
                  // }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={isSimulation || filters.country.length === 0} //disabilita se non è stato selezionato alcun country
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Legal entity"
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation || filters.country.length === 0}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                />
              </Badge>
              <Badge
                color="primary"
                badgeContent={filters.ceo_h_levels.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "250px",
                    maxHeight: "45.75px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    ceoLevels,
                    filters.ceo_h_levels,
                    false
                  )}
                  value={filters.ceo_h_levels || null}
                  label="Hierarchy"
                  // inputValue={filters.ceo_h_levels || ""}
                  onChange={(event, value) => {
                    handleFilterChange("ceo_h_levels", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("ceo_h_levels", newInputValue);
                  // }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Hierarchy"
                      variant="outlined"
                      size="small"
                      disabled={isSimulation}
                      InputLabelProps={{ shrink: undefined }}
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                />
              </Badge>
            </Box>
            <Box sx={{ display: "flex", gap: 2, mt: "2rem" }}>
              {" "}
              {/** seconda riga */}
              <Badge
                color="primary"
                badgeContent={filters.job_function.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    jobFunctions,
                    filters.job_function,
                    false
                  )}
                  value={filters.job_function || null}
                  label="Job function"
                  // inputValue={filters.job_function || ""}
                  onChange={(event, value) => {
                    handleFilterChange("job_function", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("job_function", newInputValue);
                  // }}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={isSimulation}
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Job function"
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                />
              </Badge>
              <Badge
                color="primary"
                badgeContent={filters.job_family.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    jobFamiliesOptions,
                    filters.job_family,
                    false
                  )}
                  value={filters.job_family || null}
                  label="Job family"
                  // inputValue={filters.job_family || ""}
                  onChange={(event, value) => {
                    handleFilterChange("job_family", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("job_family", newInputValue);
                  // }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={
                        isSimulation || filters.job_function.length === 0
                      } //disabilita se non è stato selezionato alun job function
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Job family"
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation || filters.job_function.length === 0}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                />
              </Badge>
              <Badge color="primary" badgeContent={filters.grade.length || 0}>
                <Autocomplete
                  multiple
                  sx={{
                    width: "250px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    grades,
                    filters.grade,
                    false
                  )}
                  value={filters.grade || null}
                  label="Grade"
                  // inputValue={filters.grade || ""}
                  onChange={(event, value) => {
                    handleFilterChange("grade", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("grade", newInputValue);
                  // }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Grade"
                      variant="outlined"
                      size="small"
                      disabled={isSimulation}
                      InputLabelProps={{ shrink: undefined }}
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                          overflow: "clip",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                />
              </Badge>
            </Box>
            <Box sx={{ display: "flex", gap: 2, mt: "2rem" }}>
              {" "}
              {/** terza riga */}
              <Badge
                color="primary"
                badgeContent={filters.person_types.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    personTypes,
                    filters.person_types
                  )}
                  value={filters.person_types || null}
                  label="Person type"
                  // inputValue={filters.person_types || ""}
                  onChange={(event, value) => {
                    handleFilterChange("person_types", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("person_types", newInputValue);
                  // }}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={isSimulation}
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Person type"
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                />
              </Badge>
              <Badge
                color="primary"
                badgeContent={filters.worker_types.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "200px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    workerTypes,
                    filters.worker_types,
                    false
                  )}
                  value={filters.worker_types || null}
                  label="Worker type"
                  // inputValue={filters.worker_types || ""}
                  onChange={(event, value) => {
                    handleFilterChange("worker_types", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("worker_types", newInputValue);
                  // }}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      disabled={isSimulation}
                      variant="outlined"
                      InputLabelProps={{ shrink: undefined }}
                      label="Worker type"
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                />
              </Badge>
              <Badge
                color="primary"
                badgeContent={filters.departments.length || 0}
              >
                <Autocomplete
                  multiple
                  sx={{
                    width: "250px",
                    maxHeight: "45.75px",
                    // marginTop: "16px",
                  }}
                  options={sortOptionsWithSelectedFirst(
                    departments,
                    filters.departments,
                    false
                  )}
                  value={filters.departments || null}
                  label="Department"
                  // inputValue={filters.department || ""}
                  onChange={(event, value) => {
                    handleFilterChange("departments", value);
                  }}
                  // onInputChange={(event, newInputValue) => {
                  //   handleFilterChange("department", newInputValue);
                  // }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Department"
                      variant="outlined"
                      size="small"
                      disabled={isSimulation}
                      InputLabelProps={{ shrink: undefined }}
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiInputBase-root": {
                          maxHeight: "45.75px",
                          overflow: "clip",
                        },
                      }}
                    />
                  )}
                  renderTags={() => null}
                  disabled={isSimulation}
                  loading
                  loadingText={
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={"12px"} />
                    </Box>
                  }
                />
              </Badge>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                mt: "2rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                <Button
                  onClick={resetFilter}
                  disabled={isSimulation}
                  variant="contained"
                  size="small"
                  sx={{
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    // marginTop: "16px",
                    backgroundColor: "#ffffff",
                    border: isSimulation
                      ? "1px solid #9e9e9e"
                      : "1px solid #00449e",
                    borderColor: isSimulation ? "#9e9e9e" : "#00449e",
                    borderRadius: "0.5rem",
                    color: "#00449e",
                    "&:hover": {
                      backgroundColor: "#eaf1fb",
                    },
                    "&:focus:not(:hover)": {
                      backgroundColor: "#eaf1fb",
                      boxShadow: "none",
                    },
                  }}
                >
                  {I18n.get("Reset filter")}
                </Button>
              </Box>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", flex: 1 }}
              >
                <Badge
                  color="primary"
                  badgeContent={filters.manager_email.length || 0}
                >
                  <Autocomplete
                    multiple
                    sx={{
                      width: "350px",
                      maxHeight: "45.75px",
                      // marginTop: "16px",
                    }}
                    options={sortOptionsWithSelectedFirst(
                      managers,
                      filters.manager_email,
                      true
                    )}
                    getOptionLabel={(option) => option.label}
                    value={filters.manager_email || null}
                    label="Manager"
                    // inputValue={filters.manager_email || ""}
                    onChange={(event, value) => {
                      handleFilterChange("manager_email", value);
                    }}
                    // onInputChange={(event, newInputValue) => {
                    //   handleFilterChange("manager_email", newInputValue);
                    // }}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Manager"
                        variant="outlined"
                        size="small"
                        disabled={isSimulation}
                        InputLabelProps={{ shrink: undefined }}
                        sx={{
                          "& .MuiInputBase-root.Mui-disabled": {
                            backgroundColor: "#f5f5f5",
                          },
                          "& .MuiInputBase-root": {
                            maxHeight: "45.75px",
                            overflow: "clip",
                          },
                        }}
                      />
                    )}
                    renderTags={() => null}
                    disabled={isSimulation}
                    loading
                    loadingText={
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress size={"12px"} />
                      </Box>
                    }
                  />
                </Badge>
              </Box>
            </Box>
          </Box>

          <DialogActions>
            <Button onClick={onClose} color="secondary">
              {I18n.get("Close")}
            </Button>
            <Button
              onClick={onSubmit}
              variant="contained"
              sx={{
                backgroundColor: "#344767",
                color: "rgb(255, 255, 255)",
                "&:hover": {
                  backgroundColor: "rgb(40, 55, 80)",
                },
                "&:focus:not(:hover)": {
                  backgroundColor: "#344767",
                  boxShadow: "none",
                },
              }}
              endIcon={<Search />}
            >
              {I18n.get("Search")}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default FilterModal;
